module.exports = __webpack_public_path__ + "static/media/069-no camera.417557dd.svg";